import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { LoadingSpinner } from './LoadingSpinner'

interface ProtectedRouteProps {
  children: React.ReactNode
  requiredRole?: 'HR' | 'employee'
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredRole 
}) => {
  const { user, appUser, loading } = useAuth()
  const location = useLocation()

  console.log('🛡️ ProtectedRoute check:', {
    user: user?.id,
    appUser: appUser?.id,
    role: appUser?.role,
    requiredRole,
    loading
  })

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-calming">
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-slate-600">Loading your wellness dashboard...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    console.log('❌ No user found, redirecting to login')
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  // For now, allow access if user exists - we'll add role checking later
  if (!appUser) {
    console.log('⚠️ User exists but no app user record found - allowing access')
    // Still allow access to dashboard, they can create user record there
  }

  // Skip role checking for now to get basic auth working
  // if (requiredRole && appUser?.role !== requiredRole) {
  //   console.log('❌ Role mismatch:', appUser?.role, 'required:', requiredRole)
  //   return <Navigate to="/unauthorized" replace />
  // }

  console.log('✅ Access granted')
  return <>{children}</>
}